import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CustomReportData} from "./custom-report.data";
import {CustomReportConfigData} from "../custom-report-config/custom-report-config.data";

@Injectable()
export class CustomReportModel extends ReportModel<CustomReportData> {
    reportConfig: CustomReportConfigData;

    constructor(injector: Injector) {
        super(injector, CustomReportData);
    }

    override isEntityLocalisable(): boolean {
        return this.reportConfig && this.reportConfig.properties.showLocationList;
    }

    protected override getCustomReportName(): string {
        return this.reportConfig && this.reportConfig.id;
    }
}
